import React from 'react';
import { SpaceScene } from './SpaceScene';
import { LogoMarquee } from './LogoMarquee';
const SOCIALS: {
  label: string;
  href: string;
  path: string;
}[] = [{
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/company/rewayz/',
  path: 'M4.98 3.5A2.5 2.5 0 1 1 0 3.5a2.5 2.5 0 0 1 4.98 0zM0 8h5v13H0V8zm7.5 0H12v1.78h.06c.63-1.13 2.17-2.32 4.46-2.32C21.28 7.46 22 10 22 13.6V21h-5v-6.6c0-1.57-.03-3.6-2.2-3.6-2.2 0-2.54 1.72-2.54 3.49V21h-5V8z'
}];
export function ComingSoon() {
  return <main className="relative flex w-full min-h-screen items-center justify-center bg-blue-reways-50 p-4 font-body sm:p-8" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/5LDtTqUigSo2kYxWCvGS9W/Sand-Texture.webp')",
    backgroundRepeat: 'repeat',
    backgroundSize: '256px 256px'
  }} data-id="element-1">
      <section className="relative w-full max-w-6xl overflow-hidden rounded-3xl bg-blue-reways-950-lock shadow-2xl shadow-blue-reways-950-lock/20" data-id="element-2">
        {/* Ambient glow */}
        <div aria-hidden="true" className="pointer-events-none absolute -top-40 -left-32 h-96 w-96 rounded-full bg-blue-reways-700/25 blur-3xl" data-id="element-3" />

        {/* Header bar */}
        <header className="relative z-10 flex flex-wrap items-center justify-between gap-4 px-6 pt-8 md:px-12 md:pt-10 lg:px-16" data-id="element-4">
          <img src="https://cdn.magicpatterns.com/uploads/sBxZrD9YQqCzEwj3hu6Bja/logo_rewayz_white.png" alt="Rewayz" className="h-9 w-auto sm:h-10" data-id="element-5" />
          <nav className="flex items-center gap-3" data-id="element-6">
            <a href="https://meetings-eu1.hubspot.com/yassin-korchi?embed=true&uuid=15e23d5e-72f4-4c1f-9e3f-891d848dd2d0" target="_blank" rel="noopener noreferrer" className="rounded-lg bg-orange-rewayz-500 px-3 py-2 text-xs font-semibold text-blue-reways-950-lock transition-colors hover:bg-yellow-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blue-reways-950-lock sm:px-4 sm:py-2.5 sm:text-sm" data-id="element-7">
              Réservez une démo
            </a>
            <a href="https://app.rewayz.com/" target="_blank" rel="noopener noreferrer" className="rounded-lg px-3 py-2 text-xs font-semibold text-blue-reways-200 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40 sm:px-4 sm:py-2.5 sm:text-sm" data-id="element-8">
              Se connecter
            </a>
          </nav>
        </header>

        <div className="relative z-10 grid grid-cols-1 items-center gap-8 px-6 py-10 md:grid-cols-2 md:gap-6 md:px-12 md:py-14 lg:px-16" data-id="element-9">
          {/* LEFT — content */}
          <div className="flex flex-col" data-id="element-10">
            {/* Heading */}
            <h1 className="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-11">
              Rewayz se fait
              <br data-id="element-12" />
              une <span className="text-orange-rewayz-500" data-id="element-13">peau neuve</span>
              <br data-id="element-14" />
              et revient bientôt.
            </h1>

            <p className="mt-5 max-w-md text-base leading-relaxed text-blue-reways-200 sm:text-lg" data-id="element-15">
              Encore un peu de patience !
            </p>

            {/* Social proof */}
            <div className="mt-10" data-id="element-16">
              <p className="text-sm font-medium text-blue-reways-200" data-id="element-17">
                <span className="font-bold text-orange-rewayz-500" data-id="element-18">
                  5 000 managers
                </span>{' '}
                utilisent déjà Rewayz
              </p>
              <div className="mt-4 max-w-md" data-id="element-19">
                <LogoMarquee data-id="element-20" />
              </div>
            </div>
          </div>

          {/* RIGHT — illustration */}
          <div className="flex items-center justify-center" data-id="element-21">
            <SpaceScene className="h-auto w-full max-w-md md:max-w-full" data-id="element-22" />
          </div>
        </div>

        {/* Footer — socials + copyright, aligned left */}
        <div className="relative z-10 flex items-center gap-4 px-6 pb-8 md:px-12 md:pb-10 lg:px-16" data-id="element-23">
          {SOCIALS.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-blue-reways-200 transition-colors hover:border-orange-rewayz-500 hover:text-orange-rewayz-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-rewayz-500/50" data-id="element-24">
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true" data-id="element-25">
                <path d={s.path} data-id="element-26" />
              </svg>
            </a>)}

          <p className="text-xs text-white" data-id="element-27">
            © {new Date().getFullYear()} Rewayz — Tous droits réservés
          </p>
        </div>
      </section>
    </main>;
}